export default __webpack_public_path__ + "static/media/riale_logo_eu.e490c574.png";